import { isMobile } from '@/lib/device'
export default [
  {
    path: '/project/:pid',
    name: 'FormLayout',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "pc-base" */ `@/components/pc/universalForm/FormLayout`
      ),
    children: [
      {
        path: 'universalform/form',
        name: 'universalForm',
        component: () =>
          import(
            /* webpackChunkName: "pc-base" */ `@/pc/universalForm/createForm/Index`
          )
      },
      {
        path: 'universalform/outsideform',
        name: 'UniversalOutsideForm',
        component: () =>
          import(
            /* webpackChunkName: "pc-base" */ `@/pc/universalForm/outsideForm/Index`
          )
      },
      {
        path: 'inquery/passdetail/:inquiryId',
        name: 'InqueryPassDetail',
        props: true,
        component: () =>
          import(/* webpackChunkName: "pc-base" */ `@/pc/inquery/passDetail/main`)
      },
      {
        path: 'clue/detail/:id',
        name: 'ClueDetail',
        props: true,
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-core" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-core" */ `@/pc/inquery/clueDetail/ClueDetail`)
      },
      {
        path: 'edm/email/edit',
        name: 'EdmEmailEdit',
        component: () =>
          import(/* webpackChunkName: "pc-base" */ `@/pc/edm/createEmail/Main`)
      },
      {
        path: 'edm/email/privew',
        name: 'EdmEmailPrivew',
        component: () =>
          import(/* webpackChunkName: "pc-base" */ `@/pc/edm/createEmail/PrivewEmail`)
      }
    ]
  }
]
